/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataViewTableDefinition } from './dataViewTableDefinition';


export interface AnalyticsDataViewRequest { 
    definition?: DataViewTableDefinition;
    /**
     * Optional analytics folder; null means root level.
     */
    folder_id?: string | null;
    name?: string;
    override_definition?: DataViewTableDefinition;
    source?: string;
    type?: AnalyticsDataViewRequest.TypeEnum;
    view_mode?: string;
}
export namespace AnalyticsDataViewRequest {
    export type TypeEnum = 'STANDARD' | 'CACHED';
    export const TypeEnum = {
        Standard: 'STANDARD' as TypeEnum,
        Cached: 'CACHED' as TypeEnum
    };
}


